<template>
  <div>
    <v-overlay :absolute="true" :opacity="1" :value="loading" :z-index="5">Loading...</v-overlay>
    <div class="main">
      <Header />
      <slot name="content"></slot>
      <div class="spacer"></div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "./header/default";
import Footer from "./footer/default";
export default {
  data() {
    return {
      loading: false
    };
  },
  components: {
    Footer,
    Header
  },
  created() {
    if (!this.$store.state.auth.authenticated) return;
    this.loading = true;
    this.$store
      .dispatch("user/fetchUserProfile")
      .then(() => (this.loading = false));
  }
};
</script>

<style scoped>
.main {
  margin: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.spacer {
  flex: 1;
}
</style>